export default __webpack_public_path__ + "static/media/star-black-outline.e545b625.svg";